/* Import lodash functions in this file first to manage library usage.
 * Always import functions module-by-module (from 'lodash/funcName') to avoid excessive bundle size. */

import isEqual from 'lodash/isEqual'
import throttle from 'lodash/throttle'
import isEmpty from 'lodash/isEmpty'

export { isEqual, isEmpty, throttle }
